<div class="opening-hours">

  <h2 class="title">Kundeservice åbningstider på telefon</h2>
  <div class="row spacer">
    <div class="col-6">Mandag-fredag</div>
    <div class="col-6">{{ openingHours }}</div>
    <div class="col-6">Lørdag-søndag</div>
    <div class="col-6">Lukket</div>
  </div>
  <div>
    <div class="bold spacer">Vær opmærksom på:</div>
    Vi holder lukket alle helligdage samt i påsken, pinsen og Kristi Himmelfartsdag. Mellem jul og nytår har vi
    åbent på telefonerne og på chatten mellem 10:00 og 16:00.
  </div>

</div>